import * as models from './models';

export enum EVENT_TYPES {
  PRODUCT_VIEW = 'epv',
  OM_CAMPAIGN_IMPRESSION = 'eoi',
  OM_CAMPAIGN_FILL = 'eof',
  OM_CAMPAIGN_CLOSE = 'eoc',
  OM_ORDER = 'eoo',
  CONSUMER_IDENTIFICATION = 'eci',
  STORE_IDENTIFICATION = 'esi',
}

export interface ClientEventBase {
  type: EVENT_TYPES;
  timestamp: number;
}

export interface ProductViewEventAttributes {
  product: models.Product;
}

export interface OmCampaignEventAttributes {
  campaign: models.Campaign;
  device: models.Device;
}

export interface OmOrderEventAttributes {
  id?: string | null;
  campaign: models.Order;
  device: models.Device;
}

export interface ProductViewEvent extends ClientEventBase {
  type: EVENT_TYPES.PRODUCT_VIEW;
  attributes: ProductViewEventAttributes;
}

export interface OmCampaignImpressionEvent extends ClientEventBase {
  type: EVENT_TYPES.OM_CAMPAIGN_IMPRESSION;
  attributes: OmCampaignEventAttributes;
}

export interface OmCampaignFillEvent extends ClientEventBase {
  type: EVENT_TYPES.OM_CAMPAIGN_FILL;
  attributes: OmCampaignEventAttributes;
}

export interface OmCampaignCloseEvent extends ClientEventBase {
  type: EVENT_TYPES.OM_CAMPAIGN_CLOSE;
  attributes: OmCampaignEventAttributes;
}

export interface OmOrderEvent extends ClientEventBase {
  type: EVENT_TYPES.OM_ORDER;
  attributes: OmOrderEventAttributes;
}

export type ClientEvent =
  | ProductViewEvent
  | OmCampaignImpressionEvent
  | OmCampaignFillEvent
  | OmCampaignCloseEvent
  | OmOrderEvent;
